import { Component, Input } from '@angular/core';
import { AlertsvarService } from '../alertsvar.service';
import { SharedService } from 'src/app/services/shared.service';
import { AlertsService } from '../alerts-custom.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/shared/custom-overlay/toast/toast.service';
import { TimeZoneService } from 'src/app/services/time-zone.service';

@Component({
  selector: 'app-set-action-panel',
  templateUrl: './set-action-panel.component.html',
  styleUrls: ['./set-action-panel.component.scss']
})
export class SetActionPanelComponent {

  constructor(
    public alertvarservice : AlertsvarService,
    public sharedService : SharedService,
    private alertservice : AlertsService,
    private toastService : ToastService,
    private timezoneservice : TimeZoneService
    )
  {}

  close_obj = {"post_status":null}

  mat_action_spinner = false

  titles={2:"Self-Assign Alert",3:"Re-Assign Alert",4:"Place Alert on Wait",5:"Close Alert",6:"Promote Alert"}

  buttonDisp={2:"Confirm Self-assign",3:"Confirm Re-assign",4:"Confirm Wait",5:"Confirm Close",6:"Confirm Promote"}

  actionDisp={2:"Self-assign",3:"Re-assign",4:"Wait",5:"Close",6:"Promote"}

  current_status = 0;

  current_status_obj:any = {}

  mode =""

  @Input() data

  disableReason = false

  actionPanelMetadata = {
    "title":"ANALYST ACTION PANEL",
    "bulk_labels":{"label1":"BULK OPERATIONS","label2":"CHECKED ALERT GROUPS"},
    "status_info":"Current Status",
    "action_headers":{"action":"NEXT STATUS ACTION","priority":"UPDATE PRIORITY (OPTIONAL)","reassign":"REASSIGN ANALYST","comment":"COMMENT (OPTIONAL)"},
    "action_buttons":{"cancel":"Cancel","save":"Save Action","acknowledge":"Acknowledge","clear":"Clear"},
    "action_placeholders":{"action":"Select Action","comment":"Select Comment (Optional)","priority":"Select Priority (Optional)","reassign":"Select Analyst"}
  }

  current_action:any = {}

  isAcknowledgeClick:boolean= false;


  action_panel = new FormGroup({
    action: new FormControl(''),
    priority: new FormControl(),
    reassign: new FormControl([Validators.required]),
    reason: new FormControl([Validators.required])
  })

  ngOnInit(){
// console.log(this.data)

    if(this.data.group.hasOwnProperty("fields")){
// console.log("dedup")
      this.mode = "dedup"
    }else{
      this.mode = "landing"
    }

    if(this.data.group.status == 0  && (this.data.action.value != 2 && this.data.action.value != 3)){
      this.disableReason = true
    }
    
    this.current_status = parseInt(this.data.group.status)

    this.getCurrentAction()
    this.action.valueChanges.subscribe((actionval)=>{
      this.resetActionPanel()
      this.getActions(actionval)
    })

    this.action_panel.get("action").setValue(this.data.action.value)
  }

  ngAfterViewInit(){

    if([4,5,6].includes(this.data.action.value)){
      this.reason.addValidators(Validators.required)
      this.reason.updateValueAndValidity()
// console.log("Validator added")
    }

    this.reassign.valueChanges.subscribe(val=>{
// console.log(val)
    })
  }

  resetActionPanel(){
    this.priority.reset()
    this.reassign.reset()
    this.reason.reset()
  }

  getCurrentAction(){
    this.action.reset()
    this.current_status_obj = this.sharedService.getCurrentStatusDisp(this.current_status)
    if(this.current_status == 0){
      this.isAcknowledgeClick = true;
      this.action.setValue(1)
    } else {
      this.isAcknowledgeClick = false;
    }
    
  }

  getReasons(action){
    if(action == 3){
      return [{"disp":"Select Comment (Optional)","value":""},...this.sharedService.getreason(action)]
    }else{
      return this.sharedService.getreason(action)
    }
    
  }


  getTitle(status){
    return this.titles[status]
  }

  getButtonDisp(status){
    return this.buttonDisp[status]
  }

  getActionDisp(status){
    return this.actionDisp[status]
  }

  async submitClick(){
    
// console.log(this.data)

    // let postObj={
    //   "alertId":this.data.alertId,
    //   "dedup":[{"fields":this.data.group.fields,"timerange":this.data.group.timerange,"status":this.data.group.status}],
    //   "action":this.data.action.value,
    //   "priority": this.priority.value,"reason": this.reason.value,"reassign": this.reassign.value,
    //   "assigned_user":[this.sharedService.analystlist.find(item => item.disp === this.sharedService.userName)?.value ?? 0]
    // }

    let postObj = this.buildReqObj('action')

// console.log(postObj)
    this.mat_action_spinner = true

    // setTimeout(() => {
    //   this.close(1)
    //   this.mat_action_spinner = false
    // }, 1000);

    let api = this.mode == 'dedup' ? this.alertservice.updateAlertActionPost : this.alertservice.actionPost

    await api.postrequest(postObj).then((val:any)=>{
// console.log(val)
      if(val?.hasOwnProperty("status") && val.status){
// console.log("Value 1")
        let status = this.alertvarservice.actionUpdateToasterMsg(this.data.action.value,val.updated_rows,1,false)
        this.close({"post_status":1,"refresh_status":status})
      }else{
// console.log("Value 0")
        this.alertvarservice.createtoastmsg({
          "type":"error", 
          "text":this.alertvarservice.toaster_message_alerts.error.update_action
        })
      }
    this.mat_action_spinner = false
    }).catch(err=>{
      this.mat_action_spinner = false
      // this.toastService.ShowToaster("Action failed",'failure')
// console.log(err)
    })
  }

  buildReqObj(type){

    let reqObj={}

    if(this.mode != 'dedup'){
      reqObj={
        "alertId":this.data.alertId,
        "platform":this.data.group.platform,
        "timerange":this.toDate(this.data.group.timerange),
        "selectedAlert":this.data.group.selectedAlert,
        "exemptedAlert":this.data.group.exemptedAlert,
        "bulk_action":false,
        // "assigned_user":[this.sharedService.analystlist.find(item => item.disp === this.sharedService.userName)?.value ?? 0],
        // "status":this.data.group.status,
        // "assigned_user":[this.sharedService.getCurrentUserId()],
        "assigned_user":[this.alertvarservice.getAnalystFilterValue()],
        "status":this.alertvarservice.getStateFilterValue(),
        "action":type == 'acknowledge' ? 2 : this.data.action.value ,
        "priority": this.priority.value,"reason": this.reason.value,"reassign": this.reassign.value,
      }
    }else{
      reqObj={
        "alertId":this.data.alertId,
        "dedup":[{"fields":this.data.group.fields,"timerange":this.data.group.timerange,"status":this.data.group.status}],
        "action":type == 'acknowledge' ? 2 : this.data.action.value ,
        "priority": this.priority.value,"reason": this.reason.value,"reassign": this.reassign.value,
        // "assigned_user":[this.sharedService.analystlist.find(item => item.disp === this.sharedService.userName)?.value ?? 0]
        // "assigned_user":[this.sharedService.getCurrentUserId()],
        "assigned_user":[this.alertvarservice.getAnalystFilterValue()],
        "status":this.alertvarservice.getStateFilterValue(),
        "bulk_action":false,
        "exemptedGroups":[],
        "timerange":this.toDate(this.alertvarservice.alertTimeFilter.value)
      }
    }

    return reqObj
    
  }

  toDate(metaDate: any) {
    let date=[this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[0]).format('YYYY-MM-DD HH:mm:ss'),this.timezoneservice.toUtcTimeZonefromUser(this.alertvarservice.calculate_timerange(metaDate)[1]).format('YYYY-MM-DD HH:mm:ss')]
    return date
  }
  

  async acknowledgeClick(){
// console.log(this.data)

    // let postObj={
    //   "alertId":this.data.alertId,
    //   "dedup":[{"fields":this.data.group.fields,"timerange":this.data.group.timerange,"status":this.data.group.status}],
    //   "action":2,
    //   "priority": this.priority.value,"reason": this.reason.value,"reassign": this.reassign.value,
    //   "assigned_user":[this.sharedService.analystlist.find(item => item.disp === this.sharedService.userName)?.value ?? 0]
    // }

    let postObj = this.buildReqObj('acknowledge')

// console.log(postObj)

    this.disableReason=false
    this.mat_action_spinner = true

    // setTimeout(() => {
    //   this.mat_action_spinner = false
    // }, 1000);

    let api = this.mode == 'dedup' ? this.alertservice.updateAlertActionPost : this.alertservice.actionPost

    await api.postrequest(postObj).then((val:any)=>{
// console.log(val)
      if(val?.status){
        if(val.updated_rows == 1){
          this.data.group.status = 2
          this.data.group.selectedAlert[0].status = 2
        }
        
        let status = this.alertvarservice.actionUpdateToasterMsg(this.data.action.value,val.updated_rows,1,false)
        if(status){
          this.close({"post_status":1,"refresh_status":status})
        } 
       
            }else{
        this.alertvarservice.createtoastmsg({
          "type":"error", 
          "text":this.alertvarservice.toaster_message_alerts.error.update_action
        })
      }
      this.mat_action_spinner = false
    }).catch(err=>{
      this.mat_action_spinner = false
      // this.toastService.ShowToaster("Alert group self-assigned failed",'failure')
// console.log(err)
    })
  }

  get action() {
    return this.action_panel.get('action') as FormControl
  }

  get priority() {
    return this.action_panel.get('priority') as FormControl
  }

  get reassign(){
    return this.action_panel.get('reassign') as FormControl
  }

  get reason (){
    return this.action_panel.get('reason') as FormControl
  }

  getActions(current_status:string){
    this.current_action = this.sharedService.actions.actions[current_status]
    this.validateReassign()
    // console.log(this.current_action)
  }

  validateReassign(){
    if(!this.isEmptyObject(this.current_action)  && this.current_action.reassign && this.data.action.value != 2){
      this.reassign.addValidators(Validators.required)
    } else {
      this.reassign.removeValidators(Validators.required)
    }
    this.reassign.updateValueAndValidity();
  }

  isEmptyObject(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

  close(val?){
    this.alertvarservice.actionPanel.close(val)
  }

}
